var map = {
	"./AA_Dante_top_1.avif": 43909,
	"./AA_Dante_top_1.png": 4665,
	"./Portrait_of_Niccolò_Machiavelli.avif": 6055,
	"./Portrait_of_Niccolò_Machiavelli.png": 67430,
	"./horse.avif": 59412,
	"./horse.png": 11860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55984;